import { Mail, Smartphone } from 'lucide-react';
import './FooterBranding.css';
import turnlinkLogo from '../../assets/turnlinkLOGO.png';

// Pie de la landing. Solo rutas reales: secciones de la propia página, soporte
// y legales (se quitaron los links sin destino: redes, blog, docs, cookies).
function FooterBranding() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-branding">
      <div className="footer-content app-container-wide">
        {/* Marca */}
        <div className="footer-section footer-brand">
          <a href="/" className="tl-wordmark" aria-label="Turnlink, inicio">
            <img src={turnlinkLogo} alt="" />
            <span>turn<em>link</em></span>
          </a>
          <p className="footer-description">
            Automatiza la gestión de citas de tu negocio con WhatsApp y sincronización a Google Calendar.
          </p>
        </div>

        {/* Producto: anclas a las secciones de la landing */}
        <div className="footer-section">
          <h4>Producto</h4>
          <nav className="footer-nav" aria-label="Secciones">
            <a href="#features">Características</a>
            <a href="#howitworks">Cómo funciona</a>
            <a href="#extras">Extras</a>
            <a href="#pricing">Precios</a>
          </nav>
        </div>

        {/* Soporte — id "contacto": es la URL de soporte que se declara en Google Pay & Wallet */}
        <div className="footer-section" id="contacto">
          <h4>Soporte</h4>
          <div className="footer-contact">
            <a href="mailto:soporte@turnlink.app">
              <Mail size={18} aria-hidden />
              soporte@turnlink.app
            </a>
            <a href="https://wa.me/13605581156" target="_blank" rel="noopener noreferrer">
              <Smartphone size={18} aria-hidden />
              +1 360 558 1156
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom app-container-wide">
        <p>© {currentYear} Turnlink. Todos los derechos reservados.</p>
        <div className="footer-legal">
          <a href="/privacy">Privacidad</a>
          <a href="/terms">Términos</a>
        </div>
      </div>
    </footer>
  );
}

export default FooterBranding;
